import React, { useMemo } from "react";
//#region redux
import { AppState } from "store";
import { useSelector } from "react-redux";
//#endregion
//#region types
import { FileMeta } from "models/utilTypes/fileUtilsTypes";
import { CommonConstants } from "utils/constants";
import { ProfileImageProps } from "models/propTypes/userProfilePropTypes";
//#endregion
//#region components
import { Avatar, Skeleton } from "@mui/material";
import useMountedState from "../useMountedState";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import LogoSmall from "images/ui_avatar_wint.png";
import DefaultAvatar from "images/avatar-person.png";
import clsx from "clsx";
import { ProfileService } from "services";

const ProfileImage: React.FC<Partial<ProfileImageProps>> = (props) => {
  const { getMounted } = useMountedState();
  const [profImage, setImage] = React.useState<FileMeta | undefined>();

  const loggedInUser = useSelector((store: AppState) => store.auth.loggedInUser);

  React.useEffect(() => {
    if (props.id !== undefined)
      if (props.id > 0) {
        loadProfImage(props.id);
      } else {
        setProfileImage("", "");
      }
    // eslint-disable-next-line eqeqeq --- disabling to avoid regression testing if changed
  }, [props.id, props.id == loggedInUser.personId && loggedInUser.profileImage]);

  const loadProfImage = (profileId: number): void => {
    // eslint-disable-next-line eqeqeq --- disabling to avoid regression testing if changed
    if (profileId == loggedInUser.personId) {
      if (loggedInUser.profileImage) {
        setProfileImage(loggedInUser.profileImage.imageData, loggedInUser.profileImage.contentType);
      } else {
        setProfileImage("", "");
      }

      return;
    }

    ProfileService.getProfileImage(profileId)
      .then((res) => {
        setProfileImage(res.imageData, res.contentType);
      })
      .catch((e) => {
        setProfileImage("", "");
      });
  };

  const setProfileImage = (imageData?: string, contentType?: string): void => {
    getMounted() &&
      setImage({
        content: imageData ? imageData : "",
        contentType: contentType ?? "",
      });
  };

  const userInitials = useMemo(() => {
    return props.name !== undefined && props.name !== null
      ? props.name
          .split(" ")
          .map((s) => s.charAt(0))
          .splice(0, 2)
          .join("")
      : "";
  }, [props.name]);

  // eslint-disable-next-line eqeqeq --- disabling to avoid regression testing if changed
  return props.id != undefined ? (
    profImage ? (
      <Avatar
        className={clsx(cssExports.profileAvatar, props.className)}
        alt={props.name}
        src={profImage.content.length > 0 ? `data:${profImage.contentType};base64,${profImage.content}` : undefined}
      >
        {userInitials}
      </Avatar>
    ) : (
      <Skeleton variant="circular" className={clsx(cssExports.profileAvatar, props.className)} />
    )
  ) : !!props.showDefaultAvatar ? (
    <Avatar className={clsx(cssExports.profileAvatar, props.className)} alt={""} src={DefaultAvatar} />
  ) : (
    <Avatar alt={CommonConstants.Wint} src={LogoSmall} className={clsx(cssExports.profileAvatar, props.className)} />
  );
};

export default ProfileImage;
